import { render, staticRenderFns } from "./PCNEventsTab.vue?vue&type=template&id=3517712b&scoped=true"
import script from "./PCNEventsTab.vue?vue&type=script&lang=js"
export * from "./PCNEventsTab.vue?vue&type=script&lang=js"
import style0 from "./PCNEventsTab.vue?vue&type=style&index=0&id=3517712b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3517712b",
  null
  
)

export default component.exports